 
/*
 map用方法混合
 * */
import {VEHICLE_TRACK} from 'static/constant.js'
export const rescueMapMixin = {
	methods:{
		//获取小车的行驶方向
		getDirection:function(direction){//判断行驶方向  W、E、N、S、EN、ES、WN、WS
		    	if(direction == "" || direction == undefined || direction == null){
					direction = "t"
				}else{
					direction = direction.replace("正",'');
					direction = direction.replace("东",'r');
					direction = direction.replace("西",'l');
					direction = direction.replace("南",'b');
					direction = direction.replace("北",'t');
					
				}
				return direction;
		},
		getRescueDirectionName(info){
			let iconName = ''
			let status = info.vehicleStatusId
			if(info.vehicleTypeId=='10'){//拖车 
				switch(status){
					case 1: //空闲中
						iconName = "trail_leisure_" +  this.getDirection(info.direction)
						break;
					case 2: //离线中
						iconName = "trail_offline_" +  this.getDirection(info.direction)
						break;
					case 3: //救援中
						iconName = "trail_rescue_" +  this.getDirection(info.direction)
						break;
				}
			}else if(info.vehicleTypeId=='11'){//路修车
				iconName = 'car_'
				switch(status){
					case 1:
						iconName = "car_run_" +  this.getDirection(info.direction)
						break;
					case 2:
						iconName = "car_offline_" +  this.getDirection(info.direction)
						break;
					case 3:
						iconName = "car_follow_" +  this.getDirection(info.direction)
						break;
				}
			}else{
				return
			} 
			return iconName
		}, 
		//根据图标名称引入不同base64图片
		getRescueUrl:function (iconName){
					var picUrl = VEHICLE_TRACK[iconName] 
					return picUrl;
		},
		//根据救援状态获取救援图标
		getSceneIconName(status){ 
			let sceneIcon = ''
			if(status=='1'){//待救援
				sceneIcon = 'alarm'
			}else if(status=='2'){//已派单
				sceneIcon = 'stop'
			}else if(status=='3'){//已完成
				sceneIcon = 'run'
			}else{
				return
			}
			return sceneIcon;
		},
		//根据sceneIcon获取对应图标名称
		getSceneIcon(name){
			let iconUrl = ''
			switch(name){
				case 'alarm':
					iconUrl = VEHICLE_TRACK.tip_icon_26
					break;
				case 'stop':
					iconUrl = VEHICLE_TRACK.tip_icon_27
					break;
				case 'run':
					iconUrl = VEHICLE_TRACK.tip_icon_28
					break;
				default:
					iconUrl = VEHICLE_TRACK.tip_icon_26
					break;
				
			}
			return iconUrl
		}
	}
}

export const getNameMixin = {
	computed:{
		vehicleTypeName(){
			return this.getVehicleTypeName(this.node.vehicleType)
		}
	},
	methods:{
		getVehicleTypeName(type){
        		let name = ''
        		if(type==10){
        			name = '拖车'
        		}else if(type==11){
        			name = '路修车'
        		}else{
        			return ''
        		} 
        		return name
       }
	}
}

export const picMixin = {
	methods:{
		showDetailPic(id,evt,item,classlist){
			var e = evt || window.event;
			let self = this;
			let shade = document.createElement('div');
		//	console.log(id)
			shade.style.height = document.querySelector(id).clientHeight+'px'; 
			shade.style.width = '100%';
			shade.style.top = document.querySelector(id).scrollTop + 'px';
			shade.classList='MaxPic'
			shade.id = id + '_MaxPic'
		//	shade.id = this.$el.id+'_MaxPic'
			let content = document.createElement('div')

			let oImg=document.createElement('img');
			if(item.photoStatus==2){
				oImg.src=this.picUrl2+item.logourl;
			}else{
				item.logourl.indexOf('http') !== -1 ? oImg.src = item.logourl : oImg.src=this.picUrl+item.logourl;
			} 
			content.appendChild(oImg);

			let titleAddress = document.createElement('p');
			titleAddress.innerHTML = '照片上传地点：'+item.uploadAddress
			content.appendChild(titleAddress);

			let titleTime = document.createElement('p');
			titleTime.innerHTML = '照片上传时间：'+item.uploadTimeStr
			content.appendChild(titleTime);

			let titlePople = document.createElement('p');
			titlePople.innerHTML = '照片上传人：'+item.uploader
			content.appendChild(titlePople);
			shade.appendChild(content)
			shade.addEventListener('click',function(e){ 
				var evt = e || window.event;
				hidden(evt)
			},false)
			document.querySelector(id).appendChild(shade)
			function hidden(e){
				var evt = e || window.event;
				if(evt.target.nodeName!='IMG'){
					shade.removeEventListener('click',hidden,false)
					document.querySelector(id).removeChild(shade)
					//	self.$el.removeChild(shade)
					classlist.toggleScroll('open',id,self);
				}
			}
			classlist.toggleScroll('close',id,self);
			e.preventDefault()
		}
	}
}
export class ShowMorePic {
	constructor(tagetName) {
		this.picIndex = 0;
		this.parent = document.querySelector(tagetName)
		this.PATH = process.env.PIC_PATH;
		this.data = [];
		this.init()
	}
	init(){
		this.content = this.createElement('div','MaxPic_Account')
		this.leftArrow = this.createElement('div','left_Account Arrow_Account')
		let leftSpan = this.createElement('span','leftArrow_Account');
		this.leftArrow.appendChild(leftSpan);
		this.addArrowEvent(this.leftArrow,-1)

		this.rightArrow = this.createElement('div','right_Account Arrow_Account')
		let rightSpan = this.createElement('span','rightArrow_Account');
		this.rightArrow.appendChild(rightSpan);
		this.addArrowEvent(this.rightArrow,1)

		let imgWrapper = this.createElement('div','imgWrapper_Account');
		this.img = this.createElement('img','')
		imgWrapper.appendChild(this.img)
		// this.renderImg()

		this.content.appendChild(this.leftArrow)
		this.content.appendChild(this.rightArrow)
		this.content.appendChild(imgWrapper)
		this.content.style.display = 'none'
		this.parent.appendChild(this.content)
		this.addRemoveEVent(this.content,this.content)
	}
	addArrowEvent(node,num){
		let self = this
		node.addEventListener('click',function(){
			self.changeIndex(num)
			self.renderImg()
		},false)
	}
	addRemoveEVent(el,targetEl){
		let self = this;
		el.addEventListener('click',function(e){
			if(e.target==targetEl){
				self.hideMaxPic()
			}
		})
	}
	hasNextPic(){
		let n = this.picIndex+1;
		let hasNextPic = this.data[n]
		return hasNextPic!=void 0;
	}
	setArrow(){
		this.leftArrow.style.display = 'block'
		this.rightArrow.style.display ='block'
		if(this.picIndex == 0){
			this.leftArrow.style.display = 'none'
		}
		if(!this.hasNextPic()){
			this.rightArrow.style.display ='none'
		}
	}
	setData(data){
		this.data = data;
		this.picIndex = 0;
	}
	showMaxPic(data){
		this.setData(data);
		if(!this.content){
			this.init(this.targetName)
		}
		this.content.style.display = 'flex';
		this.parent.style.overflow='hidden';
		this.parent.scrollTop = 0+'px'
		this.renderImg()
	}
	hideMaxPic(){
		this.content.style.display = 'none';
		this.data = [];
		this.img.src = '';
		this.parent.style.overflow='auto';
	}
	destroyed(){
		let parent = this.content.parentNode;
		parent.removeChild(this.content)
		this.content=null;
		this.parent.style.overflow='auto';
	}
	changeIndex(num){
		this.picIndex += num;
	}
	renderImg(){
		let url = this.PATH + this.data[this.picIndex]
		// let url = `https://img.infinitynewtab.com/wallpaper/${this.data[this.picIndex]}.jpg`;
		this.img.src = url;
		this.setArrow()
	}
	createElement(type,classList){
		let node = document.createElement(type);
		node.classList = classList;
		return node;
	}
}




// WEBPACK FOOTER //
// ./src/util/rescueUtil.js